import { useMapEvents } from "react-leaflet";

export const MapEvents = ({
  onMapClick,
  onMapDoubleClick,
  onMapMouseMove,
  onMapMouseOut,
}: {
  onMapClick?: (event: any) => void;
  onMapDoubleClick?: (event: any) => void;
  onMapMouseMove?: (event: any) => void;
  onMapMouseOut?: (event: any) => void;
}) => {
  useMapEvents({
    click: (event: any) => onMapClick?.(event),
    dblclick: (event: any) => onMapDoubleClick?.(event),
    mousemove: (event: any) => onMapMouseMove?.(event),
    mouseout: (event: any) => onMapMouseOut?.(event),
  });
  return null;
};
